export default "__VITE_ASSET__DZp8jTli__"